/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertSymbolFairPriceDto
 */
export interface UpsertSymbolFairPriceDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertSymbolFairPriceDto
     */
    selectedMethod: UpsertSymbolFairPriceDtoSelectedMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertSymbolFairPriceDto
     */
    symbolId: string;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    peRequiredReturn: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    peGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    peMultiple: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    fcfRequiredReturn: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    fcfGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    fcfTargetYield: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfTerminalGrowthRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfDiscountRate: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfMarginOfSafety: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfYears: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfCash: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfDebt: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpsertSymbolFairPriceDto
     */
    dcfSharesOutstanding: number | null;
}

/**
* @export
* @enum {string}
*/
export enum UpsertSymbolFairPriceDtoSelectedMethodEnum {
    Pe = 'pe',
    Fcf = 'fcf',
    Dcf = 'dcf'
}

export function UpsertSymbolFairPriceDtoFromJSON(json: any): UpsertSymbolFairPriceDto {
    return UpsertSymbolFairPriceDtoFromJSONTyped(json, false);
}

export function UpsertSymbolFairPriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSymbolFairPriceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selectedMethod': json['selectedMethod'],
        'symbolId': json['symbolId'],
        'peRequiredReturn': json['peRequiredReturn'],
        'peGrowthRate': json['peGrowthRate'],
        'peMultiple': json['peMultiple'],
        'fcfRequiredReturn': json['fcfRequiredReturn'],
        'fcfGrowthRate': json['fcfGrowthRate'],
        'fcfTargetYield': json['fcfTargetYield'],
        'dcfGrowthRate': json['dcfGrowthRate'],
        'dcfTerminalGrowthRate': json['dcfTerminalGrowthRate'],
        'dcfDiscountRate': json['dcfDiscountRate'],
        'dcfMarginOfSafety': json['dcfMarginOfSafety'],
        'dcfYears': json['dcfYears'],
        'dcfCash': json['dcfCash'],
        'dcfDebt': json['dcfDebt'],
        'dcfSharesOutstanding': json['dcfSharesOutstanding'],
    };
}

export function UpsertSymbolFairPriceDtoToJSON(value?: UpsertSymbolFairPriceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selectedMethod': value.selectedMethod,
        'symbolId': value.symbolId,
        'peRequiredReturn': value.peRequiredReturn,
        'peGrowthRate': value.peGrowthRate,
        'peMultiple': value.peMultiple,
        'fcfRequiredReturn': value.fcfRequiredReturn,
        'fcfGrowthRate': value.fcfGrowthRate,
        'fcfTargetYield': value.fcfTargetYield,
        'dcfGrowthRate': value.dcfGrowthRate,
        'dcfTerminalGrowthRate': value.dcfTerminalGrowthRate,
        'dcfDiscountRate': value.dcfDiscountRate,
        'dcfMarginOfSafety': value.dcfMarginOfSafety,
        'dcfYears': value.dcfYears,
        'dcfCash': value.dcfCash,
        'dcfDebt': value.dcfDebt,
        'dcfSharesOutstanding': value.dcfSharesOutstanding,
    };
}

